import Litepicker from 'litepicker';

(function(){
    'use strict';
    
    $(document).ready(function() {

        if ($('[data-datepicker="true"]').length > 0) {
            $('[data-datepicker="true"]').each(function() {
                var picker = new Litepicker({ element: this });
            });
        }

        $('form[data-conditional="true"]').each(function() {
            var $form = $(this);

            // Add form validation
            $form.validate({
                errorPlacement: function(error, element) {
                    if (element.closest(".sq-form-question-answer").length > 0) {
                        error.appendTo( element.closest(".sq-form-question-answer") );
                    } else {
                        error.appendTo( element.parent() );
                    }
                }
            });

            // Add custom rules if they exist
            if (typeof(addCustomRules) !== 'undefined') {
                addCustomRules();
            }

            // Add required labels to fields
            updateRequiredLabels($form);
            $form.on('change', function() {
                updateRequiredLabels($(this));
            });
        });

    });

    function updateRequiredLabels($form) {
        var $requiredFields = $form.find('.sq-form-field[required]');
            
        $requiredFields.each(function() {
            var $field = $(this);
            var $question = $field.closest('.sq-form-question');
            
            if ($question.length > 0) {
                var $requiredLabel = $question.find('.sq-form-required-field');
                
                if ($requiredLabel.length === 0) {
                    var $title = $question.find('.sq-form-question-title');
                    $title.append('<abbr class="sq-form-required-field" title="required">*</abbr>');
                }
            }
            
        });
    }
    
}());
